import React from 'react'
import FeaturedInfo from '../../featuredInfo/FeaturedInfo';
import WidgetLg from '../../widgetLg/WidgetLg';
import WidgetSmall from '../../WidgetSmall/WidgetSmall';
import "./home.css";

const Home = () => {
  return (
    <>
    <div className="home">
       <FeaturedInfo/>
    </div>
    </>
  )
}

export default Home;